<template>
  <div class="homepage-management">
    <el-tabs v-model="activeTab">
      <!-- Banner图管理 -->
      <el-tab-pane label="Banner图管理" name="banner">
        <div class="section-header">
          <h3>Banner图列表</h3>
          <el-button type="primary" @click="handleAddBanner('main')">添加Banner</el-button>
        </div>
        <el-table :data="mainBanners" style="width: 100%">
          <el-table-column prop="title" label="标题" />
          <el-table-column label="图片" width="120">
            <template #default="{ row }">
              <el-image 
                :src="row.preview_url" 
                :preview-src-list="[row.preview_url]"
                :initial-index="0"
                fit="cover"
                class="table-image"
                :preview-teleported="true"
                @click="handlePreview(row.preview_url)"
              >
                <template #viewer>
                  <div class="image-viewer-wrapper">
                    <img :src="row.image_url" class="preview-image">
                  </div>
                </template>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="link_url" label="链接" show-overflow-tooltip />
          <el-table-column prop="priority" label="排序" width="100" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditBanner(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteBanner(row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 客服二维码管理 -->
      <el-tab-pane label="客服二维码管理" name="qrcode">
        <div class="section-header">
          <h3>客服二维码</h3>
          <el-button type="primary" @click="handleEditQrcode">修改二维码</el-button>
        </div>
        <div class="qrcode-preview">
          <el-image 
            v-if="qrcode.preview_url"
            :src="qrcode.preview_url" 
            fit="contain"
            style="width: 200px; height: 200px"
          />
          <div class="qrcode-info">
            <p><strong>提示文本：</strong>{{ qrcode.text || '扫一扫添加客服' }}</p>
            <p><strong>更新时间：</strong>{{ formatTime(qrcode.updated_at) }}</p>
          </div>
        </div>
      </el-tab-pane>

      <!-- 滚动图片管理 -->
      <el-tab-pane label="滚动图片管理" name="slide">
        <div class="section-header">
          <h3>滚动图片列表</h3>
          <el-button type="primary" @click="handleAddBanner('slide')">添加滚动图片</el-button>
        </div>
        <el-table :data="slideBanners" style="width: 100%">
          <el-table-column prop="title" label="标题" />
          <el-table-column label="图片" width="120">
            <template #default="{ row }">
              <el-image 
                :src="row.preview_url" 
                :preview-src-list="[row.preview_url]"
                :initial-index="0"
                fit="cover"
                class="table-image"
                :preview-teleported="true"
                @click="handlePreview(row.preview_url)"
              >
                <template #viewer>
                  <div class="image-viewer-wrapper">
                    <img :src="row.image_url" class="preview-image">
                  </div>
                </template>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="priority" label="排序" width="100" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditBanner(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteBanner(row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 广告图管理 -->
      <el-tab-pane label="左侧广告图" name="ad_left">
        <div class="section-header">
          <h3>左侧广告图</h3>
          <el-button type="primary" @click="handleAddBanner('ad_left')">添加左侧广告图</el-button>
        </div>
        <el-table :data="leftAdBanners" style="width: 100%">
          <el-table-column prop="title" label="标题" width="180" />
          <el-table-column label="图片" width="180">
            <template #default="{ row }">
              <img 
                :src="row.preview_url" 
                class="table-image" 
                @click="handlePreview(row.preview_url)"
              >
            </template>
          </el-table-column>
          <el-table-column prop="link_url" label="链接" />
          <el-table-column prop="priority" label="排序" width="80" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditBanner(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteBanner(row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 右侧广告图标签页 -->
      <el-tab-pane label="右侧广告图" name="ad_right">
        <div class="section-header">
          <h3>右侧广告图</h3>
          <el-button type="primary" @click="handleAddBanner('ad_right')">添加右侧广告图</el-button>
        </div>
        <el-table :data="rightAdBanners" style="width: 100%">
          <el-table-column prop="title" label="标题" width="180" />
          <el-table-column label="图片" width="180">
            <template #default="{ row }">
              <img 
                :src="row.preview_url" 
                class="table-image" 
                @click="handlePreview(row.preview_url)"
              >
            </template>
          </el-table-column>
          <el-table-column prop="link_url" label="链接" />
          <el-table-column prop="priority" label="排序" width="80" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditBanner(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteBanner(row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 广告词管理 -->
      <el-tab-pane label="广告词管理" name="ticker">
        <div class="section-header">
          <h3>广告词列表</h3>
          <el-button type="primary" @click="handleAddTicker">添加广告词</el-button>
        </div>
        <el-table :data="tickers" style="width: 100%">
          <el-table-column prop="content" label="内容" />
          <el-table-column prop="priority" label="优先级" width="100" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditTicker(row)">编辑</el-button>
                <el-button 
                  size="small" 
                  type="danger" 
                  @click="handleDeleteTicker(row.id)"
                >删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 公告管理 -->
      <el-tab-pane label="公告管理" name="announcement">
        <div class="section-header">
          <h3>公告列表</h3>
          <el-button type="primary" @click="handleAddAnnouncement">添加公告</el-button>
        </div>
        <el-table :data="announcements" style="width: 100%">
          <el-table-column prop="title" label="标题" min-width="150" />
          <el-table-column label="内容" min-width="400">
            <template #default="{ row }">
              <div class="announcement-content-preview" v-html="processAnnouncementContent(row.content)"></div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditAnnouncement(row)">编辑</el-button>
                <el-button 
                  size="small" 
                  type="danger" 
                  @click="handleDeleteAnnouncement(row.id)"
                >删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 页脚管理 -->
      <el-tab-pane label="页脚管理" name="footer">
        <div class="section-header">
          <h3>页脚链接列表</h3>
          <el-button type="primary" @click="handleAddFooterLink">添加链接</el-button>
        </div>
        <el-table :data="footerLinks" style="width: 100%">
          <el-table-column prop="text" label="文本" />
          <el-table-column prop="url" label="链接" show-overflow-tooltip />
          <el-table-column prop="priority" label="排序" width="100" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'active' ? 'success' : 'info'">
                {{ row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="small" @click="handleEditFooterLink(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteFooterLink(row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 页脚链接编辑弹窗 -->
        <el-dialog
          v-model="footerLinkDialogVisible"
          :title="currentFooterLink ? '编辑链接' : '添加链接'"
          width="500px"
        >
          <el-form :model="footerLinkForm" label-width="100px" ref="footerLinkFormRef">
            <el-form-item label="文本" prop="text" :rules="[{ required: true, message: '请输入文本' }]">
              <el-input v-model="footerLinkForm.text" placeholder="请输入文本" />
            </el-form-item>
            <el-form-item label="链接" prop="url" :rules="[{ required: true, message: '请输入链接' }]">
              <el-input v-model="footerLinkForm.url" placeholder="请输入链接" />
            </el-form-item>
            <el-form-item label="排序" prop="priority">
              <el-input-number v-model="footerLinkForm.priority" :min="0" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="footerLinkForm.status">
                <el-radio label="active">启用</el-radio>
                <el-radio label="inactive">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="footerLinkDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="handleSaveFooterLink">确定</el-button>
            </span>
          </template>
        </el-dialog>
      </el-tab-pane>

      <!-- Logo管理标签页 -->
      <el-tab-pane label="Logo管理" name="logo">
        <div class="section-header">
          <h3>网站Logo</h3>
        </div>
        
        <el-form :model="logoForm" label-width="100px">
          <el-form-item label="Logo图片">
            <el-upload
              class="logo-uploader"
              action="/api/upload?type=logo"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleLogoUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeLogoUpload"
              name="file"
            >
              <img 
                v-if="logoForm.image_url" 
                :src="getFullUrl(logoForm.image_url)" 
                class="logo-image"
                @error="handleLogoImageError"
              >
              <el-icon v-else class="upload-icon"><Plus /></el-icon>
            </el-upload>
            <div v-if="logoForm.image_url" class="debug-info">
              当前Logo URL: {{ logoForm.image_url }}<br>
              完整URL: {{ getFullUrl(logoForm.image_url) }}<br>
              文件是否存在: <span id="file-exists">检查中...</span>
              <el-button type="primary" size="small" @click="fixUploadDirs" style="margin-left: 10px;">
                修复上传目录
              </el-button>
            </div>
            <div class="form-tip">建议尺寸200x60px，支持PNG格式(透明背景)</div>
          </el-form-item>

          <el-form-item label="跳转链接">
            <el-input v-model="logoForm.link_url" placeholder="点击Logo跳转的链接" />
          </el-form-item>

          <el-form-item label="替代文本">
            <el-input v-model="logoForm.alt_text" placeholder="Logo图片的alt文本" />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSaveLogo" :loading="logoSaving">
              保存Logo设置
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 通知管理 -->
      <el-tab-pane label="通知管理" name="notification">
        <NotificationManagement />
      </el-tab-pane>
    </el-tabs>

    <!-- 二维码编辑弹窗 -->
    <el-dialog
      v-model="qrcodeDialogVisible"
      title="修改客服二维码"
      width="500px"
    >
      <el-form :model="qrcodeForm" label-width="100px">
        <el-form-item label="二维码图片">
          <el-upload
            class="banner-uploader"
            :action="`${backendUrl}/file/upload/image`"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleQrcodeUploadSuccess"
            :on-error="handleQrcodeUploadError"
            :before-upload="beforeQrcodeUpload"
            name="file"
          >
            <img v-if="qrcodeForm.preview_url" :src="qrcodeForm.preview_url" class="uploaded-image">
            <el-button v-else type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="提示文本">
          <el-input v-model="qrcodeForm.text" placeholder="请输入提示文本" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="qrcodeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveQrcode">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Banner编辑弹窗 -->
    <BannerDialog
      v-model:visible="bannerDialogVisible"
      :type="currentBannerType"
      :edit-data="currentBanner"
      @success="fetchData"
    />

    <!-- 广告词编辑弹窗 -->
    <el-dialog
      v-model="tickerDialogVisible"
      :title="currentTicker ? '编辑广告词' : '添加广告词'"
      width="500px"
    >
      <el-form :model="tickerForm" label-width="100px" ref="tickerFormRef">
        <el-form-item label="内容" prop="content" :rules="[{ required: true, message: '请输入广告词内容' }]">
          <el-input v-model="tickerForm.content" placeholder="请输入广告词内容" />
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <el-input-number v-model="tickerForm.priority" :min="0" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="tickerForm.status">
            <el-radio label="active">启用</el-radio>
            <el-radio label="inactive">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="tickerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveTicker">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 公告编辑弹窗 -->
    <el-dialog
      v-model="announcementDialogVisible"
      :title="currentAnnouncement ? '编辑公告' : '添加公告'"
      width="800px"
      :before-close="handleCloseAnnouncementDialog"
    >
      <el-form :model="announcementForm" label-width="100px" ref="announcementFormRef">
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入公告标题' }]">
          <el-input v-model="announcementForm.title" placeholder="请输入公告标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content" :rules="[{ required: true, message: '请输入公告内容' }]">
          <div class="editor-container">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editorRef"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 300px"
              v-model="announcementForm.content"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="handleEditorCreated"
            />
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="announcementForm.status">
            <el-radio label="active">启用</el-radio>
            <el-radio label="inactive">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCloseAnnouncementDialog">取消</el-button>
          <el-button type="primary" @click="handleSaveAnnouncement">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, shallowRef, onBeforeUnmount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import BannerDialog from '@/components/banner/BannerDialog.vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { Plus } from '@element-plus/icons-vue'
import NotificationManagement from '@/components/admin/NotificationManagement.vue'
import request from '@/api/request';
import requestV2 from '@/utils/requestV2';




const activeTab = ref('banner')

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL)


const bannerTypes = {
  main: '主Banner',
  slide: '滚动图片',
  ad: '广告图',
  ad_left: '左侧广告图',
  ad_right: '右侧广告图'
}

// 数据列表
const mainBanners = ref([])
const slideBanners = ref([])
const adBanners = ref([])
const leftAdBanners = ref([])
const rightAdBanners = ref([])
const tickers = ref([])
const announcements = ref([])

// 二维码相关
const qrcode = ref({
  id: 1,
  image_url: '',
  preview_url: '',
  text: '',
  updated_at: ''
})

const qrcodeDialogVisible = ref(false)
const qrcodeForm = ref({
  image_url: '',
  preview_url: '',
  text: ''
})

const bannerDialogVisible = ref(false)
const currentBannerType = ref<'main' | 'slide' | 'ad' | 'ad_left' | 'ad_right'>('main')
const currentBanner = ref<Banner | null>(null)

// 广告词相关状态
const tickerDialogVisible = ref(false)
const currentTicker = ref<Ticker | null>(null)
const tickerForm = ref({
  content: '',
  priority: 0,
  status: 'active'
})
const tickerFormRef = ref()

// 公告相关状态
const announcementDialogVisible = ref(false)
const currentAnnouncement = ref<Announcement | null>(null)
const announcementForm = ref({
  title: '',
  content: '',
  status: 'active'
})
const announcementFormRef = ref()

// 页脚相关状态
const footerLinks = ref([])
const footerLinkDialogVisible = ref(false)
const currentFooterLink = ref<FooterLink | null>(null)
const footerLinkForm = ref({
  text: '',
  url: '',
  priority: 0,
  status: 'active'
})
const footerLinkFormRef = ref()

// Logo相关状态
const logoForm = ref({
  image_url: '',
  link_url: '/',
  alt_text: '简单画素材网'
});
const logoSaving = ref(false);

// 上传相关
const uploadHeaders = computed(() => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`
}))

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 编辑器配置
const toolbarConfig = {
  excludeKeys: [] // 可以配置需要排除的菜单项
}

const editorConfig = {
  placeholder: '请输入内容...',
  MENU_CONF: {
    uploadImage: {
      server: '/api/upload',
      fieldName: 'file',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      customInsert: (res: any, insertFn: any) => {
        // res 即服务端返回的数据
        if (res.url) {
          insertFn(res.url)
        } else {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const handleEditorCreated = (editor: any) => {
  editorRef.value = editor
}

const handleCloseAnnouncementDialog = () => {
  const editor = editorRef.value
  if (editor) {
    editor.clear()
  }
  announcementDialogVisible.value = false
}

// 上传前检查
const beforeQrcodeUpload = (file: File) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    ElMessage.error('只能上传图片文件!')
    return false
  }
  const isLt5M = file.size / 1024 / 1024 < 5
  if (!isLt5M) {
    ElMessage.error('图片大小不能超过 5MB!')
    return false
  }
  return true
}

// 上传成功处理
const handleQrcodeUploadSuccess = async (response: any) => {
  console.log('Upload success:', response);
    if (response.code == 0) {
    const objectName =  response.data.objectName;
    const res =  await requestV2.post('/file/getImagePreview', {
      objectName: objectName,
    })
    if(res.data.code == 0){
      qrcodeForm.value.image_url = objectName;
      qrcodeForm.value.preview_url = res.data.data.data.url;
    }
  } else {
    ElMessage.error('上传失败')
  }
}

// 上传失败处理
const handleQrcodeUploadError = (error: Error) => {
  console.error('Upload error:', error)
  ElMessage.error('上传失败，请检查网络连接')
}

// 获取数据
const fetchData = async () => {
  try {
    console.log('Fetching data...');
    const token = localStorage.getItem('token');
    const headers = {
      'Authorization': `Bearer ${token}`
    };

    // 获取公告数据
    const announcementsRes = await requestV2.get('/system/announcements/all');

    if (announcementsRes.data.code == 200) {
      const data = await announcementsRes.data.data
      console.log('Announcements data:', data);
      announcements.value = data;
    } else {
      console.error('Failed to fetch announcements:',announcementsRes.data.data);
    }

    // 分别获取不同类型的banner
    const [mainRes, slideRes, adRes, leftAdRes, rightAdRes, tickersRes, qrcodeRes, footerRes] = await Promise.all([
      fetch(`${backendUrl.value}/system/banners/main`, { headers }),
      fetch(`${backendUrl.value}/system/banners/slide`, { headers }),
      fetch(`${backendUrl.value}/system/banners/ad`, { headers }),
      fetch(`${backendUrl.value}/system/banners/ad_left`, { headers }),
      fetch(`${backendUrl.value}/system/banners/ad_right`, { headers }),
      fetch(`${backendUrl.value}/system/tickerTexts/getTicker`, { headers }),
      fetch(`${backendUrl.value}/system/qrcode/getQrCode`, { headers }),
      fetch(`${backendUrl.value}/system/footer/getFooter`, { headers })
    ]);

    if (mainRes.ok) {
      const data = await mainRes.json();
      console.log('Main banners:', data);
      mainBanners.value = data.data;
    }

    if (slideRes.ok) {
      const data = await slideRes.json();
      console.log('Slide banners:', data);
      slideBanners.value = data.data;
    }

    if (adRes.ok) {
      const data = await adRes.json();
      console.log('Ad banners:', data);
      adBanners.value = data.data;
    }

    if (leftAdRes.ok) {
      const data = await leftAdRes.json();
      console.log('Left ad banners:', data);
      leftAdBanners.value = data.data;
    }

    if (rightAdRes.ok) {
      const data = await rightAdRes.json();
      console.log('Right ad banners:', data);
      rightAdBanners.value = data.data;
    }

    if (tickersRes.ok) {
      const data = await tickersRes.json();
      tickers.value = data.data;
    }
    if (qrcodeRes.ok){
      const data = await qrcodeRes.json();
      qrcode.value = data.data;
    } 
    if (footerRes.ok) {
      const data = await footerRes.json();
      footerLinks.value = data.data;
    }

    // 获取Logo数据
    const logoResponse = await fetch(`${backendUrl.value}/system/siteLogo/getLogo`);
    if (logoResponse.ok) {
      const logoData = await logoResponse.json();
      if (logoData) {
        logoForm.value = logoData.data;
      }
    }
  } catch (error) {
    console.error('获取数据失败:', error);
    ElMessage.error('获取数据失败');
  }
};

// 添加类型定义
interface Banner {
  id: number
  type: 'main' | 'slide' | 'ad' | 'ad_left' | 'ad_right'
  title: string
  image_url: string
  link_url?: string
  status: 'active' | 'inactive'
}

interface Ticker {
  id: number
  content: string
  priority: number
  status: 'active' | 'inactive'
}

interface Announcement {
  id: number
  title: string
  content: string
  status: 'active' | 'inactive'
}

interface FooterLink {
  id: number
  text: string
  url: string
  priority: number
  status: 'active' | 'inactive'
}

// 添加 mode 变量
const mode = ref('default')

// 修改处理函数的参数类型
const handleEditBanner = (banner: Banner) => {
  currentBannerType.value = banner.type
  currentBanner.value = banner
  bannerDialogVisible.value = true
}

const handleDeleteBanner = async (id: number) => {
  try {
    await ElMessageBox.confirm('确定要删除这个Banner吗？')
    const res = await requestV2.delete(`/system/banners/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    
    if (res.data.code == 200) {
      ElMessage.success('删除成功');
      qrcodeDialogVisible.value = false;
      await fetchData();
    } else {
      const error = res.data;
      console.error('Save error response:', error);
      ElMessage.error(error.message || '删除成功');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除Banner失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

// 广告词相关操作
const handleAddTicker = () => {
  currentTicker.value = null
  tickerForm.value = {
    content: '',
    priority: 0,
    status: 'active'
  }
  tickerDialogVisible.value = true
}

const handleEditTicker = (ticker: Ticker) => {
  currentTicker.value = ticker
  tickerForm.value = {
    content: ticker.content,
    priority: ticker.priority,
    status: ticker.status
  }
  tickerDialogVisible.value = true
}

const handleSaveTicker = async () => {
  try {
    await tickerFormRef.value.validate()

    const url = currentTicker.value 
      ? `/api/tickers/${currentTicker.value.id}`
      : '/api/tickers'
    
    const res = await fetch(url, {
      method: currentTicker.value ? 'PUT' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(tickerForm.value)
    })

    if (res.ok) {
      ElMessage.success(currentTicker.value ? '更新成功' : '添加成功')
      tickerDialogVisible.value = false
      await fetchData()
    } else {
      const error = await res.json()
      ElMessage.error(error.message || '保存失败')
    }
  } catch (error) {
    console.error('保存广告词失败:', error)
    ElMessage.error('保存失败')
  }
}

const handleDeleteTicker = async (id: number) => {
  try {
    await ElMessageBox.confirm('确定要删除这条广告词吗？')
    const res = await fetch(`/api/tickers/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`  // 添加认证头
      }
    })
    
    if (res.ok) {
      ElMessage.success('删除成功')
      await fetchData()
    } else {
      const error = await res.json()
      ElMessage.error(error.message || '删除失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除广告词失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

// 公告相关操作
const handleAddAnnouncement = () => {
  currentAnnouncement.value = null
  announcementForm.value = {
    title: '',
    content: '',
    status: 'active'
  }
  announcementDialogVisible.value = true
}

const handleEditAnnouncement = (announcement: Announcement) => {
  currentAnnouncement.value = announcement
  announcementForm.value = {
    title: announcement.title,
    content: announcement.content,
    status: announcement.status
  }
  announcementDialogVisible.value = true
}

const handleSaveAnnouncement = async () => {
  try {
    await announcementFormRef.value.validate()

    const url = currentAnnouncement.value 
      ? `/api/announcements/${currentAnnouncement.value.id}`
      : '/api/announcements'
    
    const res = await fetch(url, {
      method: currentAnnouncement.value ? 'PUT' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(announcementForm.value)
    })

    if (res.ok) {
      ElMessage.success(currentAnnouncement.value ? '更新成功' : '添加成功')
      announcementDialogVisible.value = false
      await fetchData()
    } else {
      const error = await res.json()
      ElMessage.error(error.message || '保存失败')
    }
  } catch (error) {
    console.error('保存公告失败:', error)
    ElMessage.error('保存失败')
  }
}

const handleDeleteAnnouncement = async (id: number) => {
  try {
    await ElMessageBox.confirm('确定要删除这条公告吗？')
    const res = await fetch(`/api/announcements/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`  // 添加认证头
      }
    })
    
    if (res.ok) {
      ElMessage.success('删除成功')
      await fetchData()
    } else {
      const error = await res.json()
      ElMessage.error(error.message || '删除失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除公告失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

// 二维码相关操作
const handleEditQrcode = () => {
  qrcodeForm.value = {
    image_url: qrcode.value.image_url,
    text: qrcode.value.text
  }
  qrcodeDialogVisible.value = true
}

const handleSaveQrcode = async () => {
  try {
    console.log('Saving qrcode:', qrcodeForm.value);

    const res = await requestV2.post('/system/qrcode/saveQrCode',qrcodeForm.value);


    if (res.data.code == 200) {
      ElMessage.success('保存成功');
      qrcodeDialogVisible.value = false;
      await fetchData();
    } else {
      const error = res.data;
      console.error('Save error response:', error);
      ElMessage.error(error.message || '保存失败');
    }
  } catch (error) {
    console.error('保存二维码失败:', error);
    ElMessage.error('保存失败');
  }
}

// 添加图片预览处理函数
const handlePreview =  (url: string) => {
 // 预览图片时的额外处理（如果需要）
  if(url){
    // 上传成功
    request.post(`${backendUrl.value}/file/getImagePreview`, {
      objectName: url,
    }).then((res: any) => {
      console.log("res.data.data.url    ",res.data.data.url)
      return res.data.data.url;
    })
  }
}
// 添加时间格式化函数
const formatTime = (timestamp: string) => {
  if (!timestamp) return '-';
  const date = new Date(timestamp);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
}

// 处理公告内容预览
const processAnnouncementContent = (content: string) => {
  if (!content) return '';
  return content.replace(/<img/g, '<img class="announcement-preview-image"');
}

// 页脚相关操作
const handleAddFooterLink = () => {
  currentFooterLink.value = null
  footerLinkForm.value = {
    text: '',
    url: '',
    priority: 0,
    status: 'active'
  }
  footerLinkDialogVisible.value = true
}

const handleEditFooterLink = (link: FooterLink) => {
  currentFooterLink.value = link
  footerLinkForm.value = { ...link }
  footerLinkDialogVisible.value = true
}

const handleSaveFooterLink = async () => {
  try {
    await footerLinkFormRef.value.validate()

    const url = currentFooterLink.value 
      ? `/api/footer/${currentFooterLink.value.id}`
      : '/api/footer'
    
    console.log('Saving footer link:', {
      url,
      method: currentFooterLink.value ? 'PUT' : 'POST',
      data: footerLinkForm.value
    });

    const res = await fetch(url, {
      method: currentFooterLink.value ? 'PUT' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(footerLinkForm.value)
    })

    console.log('Save response:', {
      status: res.status,
      ok: res.ok
    });

    if (res.ok) {
      ElMessage.success(currentFooterLink.value ? '更新成功' : '添加成功')
      footerLinkDialogVisible.value = false
      await fetchData()
    } else {
      const error = await res.json()
      console.error('Save error response:', error);
      ElMessage.error(error.message || '保存失败')
    }
  } catch (error) {
    console.error('保存页脚链接失败:', error)
    ElMessage.error('保存失败')
  }
}

const handleDeleteFooterLink = async (id: number) => {
  try {
    await ElMessageBox.confirm('确定要删除这个链接吗？')
    const res = await fetch(`/api/footer/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    
    if (res.ok) {
      ElMessage.success('删除成功')
      await fetchData()
    } else {
      const error = await res.json()
      ElMessage.error(error.message || '删除失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除页脚链接失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

// Logo相关操作
const handleLogoUploadSuccess = (response: any) => {
  if (response.success && response.url) {
    // 确保 URL 以斜杠开头
    const logoUrl = response.url.startsWith('/') ? response.url : `/${response.url}`;
    logoForm.value.image_url = logoUrl;
    
    console.log('Logo upload success:', {
      response,
      logoUrl,
      formData: logoForm.value
    });
    
    // 立即保存 Logo 设置
    handleSaveLogo();
  } else {
    console.error('Invalid upload response:', response);
    ElMessage.error('上传失败：返回数据格式错误');
  }
};

// 处理 Logo 图片加载错误
const handleLogoImageError = async (e: Event) => {
  const img = e.target as HTMLImageElement;
};

// 保存 Logo 设置
const handleSaveLogo = async () => {
  try {
    logoSaving.value = true;
    console.log('Saving logo with data:', logoForm.value);

    const response = await fetch('/api/logo', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(logoForm.value)
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Logo saved:', data);
      ElMessage.success('Logo设置保存成功');
      // 刷新数据
      await fetchData();
    } else {
      const error = await response.json();
      throw new Error(error.message || '保存失败');
    }
  } catch (error: any) {
    console.error('保存Logo设置失败:', error);
    ElMessage.error(error.message || '保存Logo设置失败');
  } finally {
    logoSaving.value = false;
  }
};

// 使用 bannerTypes
const bannerTypeLabel = computed(() => {
  return bannerTypes[currentBannerType.value] || ''
})

// 添加 handleAddBanner 函数
const handleAddBanner = (type: 'main' | 'slide' | 'ad' | 'ad_left' | 'ad_right') => {
  currentBannerType.value = type
  currentBanner.value = null
  bannerDialogVisible.value = true
}

// 添加 beforeLogoUpload 函数
const beforeLogoUpload = (file: File) => {
  const isPNG = file.type === 'image/png';
  if (!isPNG) {
    ElMessage.error('Logo只能是PNG格式!');
    return false;
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    ElMessage.error('Logo图片大小不能超过 2MB!');
    return false;
  }
  return true;
};

// 添加 handleUploadError 函数
const handleUploadError = (error: any) => {
  console.error('Logo upload error:', error);
  if (error.message && typeof error.message === 'string') {
    try {
      const errorData = JSON.parse(error.message);
      ElMessage.error(errorData.message || '上传失败');
    } catch {
      ElMessage.error(error.message || '上传失败');
    }
  } else {
    ElMessage.error('上传失败');
  }
};

// 修改模板中使用 window 的部分
const getFullUrl = (url: string) => {
  if (!url) return '';
  
  // 检查URL是否已经是绝对URL
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // 获取API的基础URL
  const apiBase = import.meta.env.DEV 
    ? 'http://localhost:3000' // 开发环境直接使用后端地址
    : window.location.origin; // 生产环境使用当前域名
  
  // 确保url以/开头
  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
  
  return `${apiBase}${normalizedUrl}`;
};

// 添加 fixUploadDirs 函数
const fixUploadDirs = async () => {
  try {
    console.log('修复上传目录...');
    
    // 显示加载中提示
    ElMessage({
      message: '正在修复上传目录结构...',
      type: 'info'
    });
    
    // 调用后端API创建目录
    const response = await fetch('/api/upload/create-dirs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      console.log('目录修复结果:', data);
      
      // 计算统计信息
      const stats = {
        total: data.results.length,
        created: data.results.filter(r => r.status === '创建成功').length,
        existing: data.results.filter(r => r.status === '已存在').length,
        failed: data.results.filter(r => r.status === '失败').length
      };
      
      ElMessage({
        message: `上传目录结构修复完成。总计: ${stats.total}, 新建: ${stats.created}, 已存在: ${stats.existing}, 失败: ${stats.failed}`,
        type: 'success',
        duration: 5000
      });
      
      // 如果当前有图片URL，尝试重新加载图片
      if (logoForm.value.image_url) {
        const img = document.querySelector('.logo-image');
        if (img) {
          img.src = getFullUrl(logoForm.value.image_url) + '?t=' + new Date().getTime();
        }
      }
    } else {
      const error = await response.json();
      throw new Error(error.message || '修复失败');
    }
  } catch (error) {
    console.error('修复上传目录失败:', error);
    ElMessage.error('修复上传目录失败: ' + (error.message || '未知错误'));
  }
};

onMounted(fetchData)
</script>

<style scoped>
.homepage-management {
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
}

.qrcode-preview {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  gap: 20px;
  align-items: center;
}

.qrcode-info {
  flex: 1;
}

.qrcode-info p {
  margin: 10px 0;
}

.qrcode-uploader {
  text-align: center;
}

.uploaded-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 4px;
}

.qrcode-uploader :deep(.el-upload) {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
}

.qrcode-uploader :deep(.el-upload:hover) {
  border-color: #409EFF;
}

.table-image {
  width: 100px;
  height: 60px;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s;
}

.table-image:hover {
  transform: scale(1.05);
}

/* 预览图样式 */
:deep(.el-image-viewer__wrapper) {
  background-color: rgba(0, 0, 0, 0.8);
}

:deep(.el-image-viewer__close) {
  color: #fff;
  font-size: 24px;
}

:deep(.el-image-viewer__img) {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}

:deep(.el-image-viewer__actions) {
  opacity: 0.8;
}

:deep(.el-image-viewer__actions__inner) {
  padding: 8px 16px;
}

:deep(.el-image-viewer__btn) {
  color: #fff;
}

:deep(.el-image-viewer__mask) {
  opacity: 0.8;
}

.editor-container {
  border: 1px solid #ccc;
  z-index: 100; /* 确保编辑器菜单不被遮挡 */
}

:deep(.w-e-text-container) {
  min-height: 300px !important;
}

.announcement-content-preview {
  max-height: 120px;
  min-height: 60px;
  overflow: hidden;
  position: relative;
  padding: 8px;
  line-height: 1.5;
}

:deep(.announcement-preview-image) {
  max-width: 100px;
  max-height: 60px;
  object-fit: contain;
  margin: 4px 8px 4px 0;
  border-radius: 4px;
  display: inline-block;
  vertical-align: top;
  float: left;
}

.announcement-content-preview::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: linear-gradient(transparent, white 90%);
  pointer-events: none;
}

:deep(p) {
  margin: 0 0 8px 0;
}

:deep(a) {
  color: #409EFF;
  text-decoration: none;
}

:deep(strong, b) {
  font-weight: 600;
}

.logo-uploader {
  width: 200px;
}

.logo-image {
  width: 200px;
  height: 60px;
  object-fit: contain;
}

.upload-icon {
  width: 200px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.upload-icon:hover {
  border-color: var(--el-color-primary);
}

.form-tip {
  font-size: 0.8em;
  color: #909399;
  margin-top: 8px;
}

.debug-info {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  word-break: break-all;
}
</style> 